import Form from "@/pages/Form";
import React from "react";

const StaticbarDashboard = () => {
  return (
    <>
      <div className="rbt-static-bar">
        <Form />

        <p className="b3 small-text">
          Ai can make mistakes. Consider checking important information.
        </p>
      </div>
    </>
  );
};

export default StaticbarDashboard;
